import Vue from 'vue'
import Vuex from 'vuex'

import VuexPersistence from 'vuex-persist'
import setStore from './set_store'

Vue.use(Vuex)

const persist = new VuexPersistence({
    key: 'set',
    storage: window.localStorage
}).plugin

const store = new Vuex.Store({
    plugins: [persist],
    modules: {
        set: setStore
    }
})

//don't do this because it's slow - instead, load user state from persisted store
//it's slow because we need to wait for authStateChanged everytime we refresh the page in router.beforeEach hook
// auth.onAuthStateChanged(function(user) {
//     console.log(user)
//     store.commit('user/setData', user)
// })

export default store